import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
import { qualifyUrl } from "util/URLUtils";
import { urlPrefix } from "./useArchiveConfig";
const url = qualifyUrl(`${urlPrefix}/config/snapshot-archiving/defaults`);
const useSnapshotArchivingDefaults = () => useQuery({
  queryKey: ["snapshotArchivingDefaults"],
  queryFn: () => defaultOnError(
    fetch("GET", url),
    "Loading snapshot archiving defaults failed with status",
    "Could not load snapshot archiving defaults."
  ),
  staleTime: 6e4
});
export default useSnapshotArchivingDefaults;
